import { render, staticRenderFns } from "./EmailWithConfirm.vue?vue&type=template&id=53f05fda&scoped=true&"
import script from "./EmailWithConfirm.vue?vue&type=script&lang=js&"
export * from "./EmailWithConfirm.vue?vue&type=script&lang=js&"
import style0 from "./EmailWithConfirm.vue?vue&type=style&index=0&id=53f05fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f05fda",
  null
  
)

export default component.exports